
import Checkbok from '../checkbox/index.jsx'
import CheckboxItem from '../checkbox/item.jsx'
import React from 'react'
import { Input } from 'antd'
import SetColor from '../setColor/index.jsx'
import Slider from '../slider/index.jsx'

export default function Card2(props) {
  return <React.Fragment>
    <div className='suspensionSide_item'>
      <span className='item_title'>关注方式</span>
      <div className='item_mainTransverse'>
        <Checkbok list={props.ifon.attentionMode} change={(list) => {
          props.ifon.attentionMode = list
          props.mySetIfon(props.ifon)
        }}>
          <CheckboxItem id={1}>复制微信</CheckboxItem>
          <CheckboxItem id={2}>分享朋友圈</CheckboxItem>
        </Checkbok>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>公众号链接</span>
      <div className='item_mainColumn'>
        <div className='item'>
          <Input value={props.ifon.officialAccountLink} placeholder='请输入公众号链接' onChange={(e) => {
            props.ifon.officialAccountLink = e.target.value
            props.mySetIfon(props.ifon)
          }} />
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>按钮文本</span>
      <div className='item_mainColumn'>
        <div className='item'>
          <Input showCount maxLength={20} value={props.ifon.cardStyle.card2.text} onChange={(e) => {
            props.ifon.cardStyle.card2.text = e.target.value
            props.mySetIfon(props.ifon)
          }} />
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>卡片颜色</span>
      <div className='item_mainTransverse'>
        <ul className='item_ul'>
          <li className='ul_li'>
            <span className='li_span'>文字</span>
            <SetColor color={props.ifon.cardColor} setColor={(obj) => {
              props.ifon.cardColor = obj.hex
              props.mySetIfon(props.ifon)
            }}></SetColor>
          </li>
          <li className='ul_li'>
            <span className='li_span'>背景</span>
            <SetColor color={props.ifon.cardBackColor} setColor={(obj) => {
              props.ifon.cardBackColor = obj.hex
              props.mySetIfon(props.ifon)
            }}></SetColor>
          </li>
        </ul>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>字号</span>
      <div className='item_mainColumn'>
        <div className='item'>
          <Slider defaultValue={props.ifon.fontSize} change={(value) => {
            props.ifon.fontSize = value
            props.mySetIfon(props.ifon)
          }}></Slider>
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>尺寸</span>
      <div className='item_mainColumn'>
        <div className='item'>
          <Slider maxValue={22} defaultValue={props.ifon.width} change={(value) => {
            props.ifon.width = value
            props.mySetIfon(props.ifon)
          }}>宽度</Slider>
        </div>
        <div className='item'>
          <Slider defaultValue={props.ifon.cardStyle.card2.height} change={(value) => {
            props.ifon.cardStyle.card2.height = value
            props.mySetIfon(props.ifon)
          }}>高度</Slider>
        </div>
        <div className='item'>
          <Slider maxValue={15} defaultValue={props.ifon.fillet} change={(value) => {
            props.ifon.fillet = value
            props.mySetIfon(props.ifon)
          }}>圆角</Slider>
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>布局</span>
      <div className='item_mainTransverse'>
        <ul className='ulBox' onClick={(e) => {
          const text = e.target.dataset.index
          if (text) {
            props.ifon.layout = parseFloat(text)
            props.mySetIfon(props.ifon)
          }
        }}>
          <li className={`BoxLi ${props.ifon.layout === 0 ? 'active' : ''}`} data-index={0}>居左</li>
          <li className={`BoxLi ${props.ifon.layout === 1 ? 'active' : ''}`} data-index={1}>居中</li>
          <li className={`BoxLi ${props.ifon.layout === 2 ? 'active' : ''}`} data-index={2}>居右</li>
        </ul>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>边距</span>
      <div className='item_mainColumn'>
        <div className='item'>
          <Slider defaultValue={props.ifon.paddingTop} change={(value) => {
            props.ifon.paddingTop = value
            props.mySetIfon(props.ifon)
          }}>上</Slider>
        </div>
        <div className='item'>
          <Slider defaultValue={props.ifon.paddingBottom} change={(value) => {
            props.ifon.paddingBottom = value
            props.mySetIfon(props.ifon)
          }}>下</Slider>
        </div>
        <div className='item'>
          <Slider defaultValue={props.ifon.paddingLeft} change={(value) => {
            props.ifon.paddingLeft = value
            props.mySetIfon(props.ifon)
          }}>左</Slider>
        </div>
        <div className='item'>
          <Slider defaultValue={props.ifon.paddingRight} change={(value) => {
            props.ifon.paddingRight = value
            props.mySetIfon(props.ifon)
          }}>右</Slider>
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>固定悬浮</span>
      <div className='item_mainTransverse'>
        <div className={`switch ${props.ifon.isSuspension ? 'open' : ''}`}>
          <i className='switch_icon' onClick={() => {
            props.ifon.isSuspension = !props.ifon.isSuspension
            props.mySetIfon(props.ifon)
          }}></i>
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>与底部距离</span>
      <div className='item_mainColumn'>
        <div className='item'>
          <Slider defaultValue={props.ifon.bottomDistance} change={(value) => {
            props.ifon.bottomDistance = value
            props.mySetIfon(props.ifon)
          }}></Slider>
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>页尾留白</span>
      <div className='item_mainColumn'>
        <div className='item'>
          <Slider maxValue={200} defaultValue={props.ifon.message} change={(value) => {
            props.ifon.message = value
            props.mySetIfon(props.ifon)
          }}></Slider>
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>引导图片</span>
      <div className='item_mainTransverse'>
        <div className={`switch ${props.ifon.isGuide ? 'open' : ''}`}>
          <i className='switch_icon' onClick={() => {
            props.ifon.isGuide = !props.ifon.isGuide
            props.mySetIfon(props.ifon)
          }}></i>
        </div>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>引导悬浮</span>
      <div className='item_mainTransverse'>
        <div className={`switch ${props.ifon.floatingLayer ? 'open' : ''}`}>
          <i className='switch_icon' onClick={() => {
            props.ifon.floatingLayer = !props.ifon.floatingLayer
            props.mySetIfon(props.ifon)
          }}></i>
        </div>
        <span className='switch_tips'>点击加粉按钮后显示引导弹层，然后再跳转至微信；若落地页页面中已含有引导信息，可关闭该浮层。</span>
      </div>
    </div>
  </React.Fragment>
}
